import md5 from 'md5'; // Import md5 library
import { baseUrl } from './consts';

const authProvider = {
    login: ({ username, password }) => {
        const hashedPassword = md5(password);

        const request = new Request(baseUrl+'/v1/manager-auth', {
            method: 'POST',
            body: JSON.stringify({ managername: username, password: hashedPassword }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error('Invalid credentials');
                }
                return response.json();
            })
            .then(auth => {
                localStorage.setItem('auth_token', auth.access_token);
                localStorage.setItem('refresh_token', auth.refresh_token);
            });
    },
    logout: () => {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('refresh_token');
        return Promise.resolve();
    },
    checkAuth: () => {
        const accessToken = localStorage.getItem('auth_token');
        if (!accessToken) {
            return Promise.reject({ redirectTo: '/login' });
        }

        const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp < currentTime) {
            return authProvider.refreshToken().then(() => Promise.resolve()).catch(() => {
                authProvider.logout();
                return Promise.reject({ redirectTo: '/login' });
            });
        }

        return Promise.resolve();
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            return authProvider.refreshToken().catch(() => {
                authProvider.logout();
                return Promise.reject({ redirectTo: '/login' });
            });
        }
        return Promise.resolve();
    },
    getPermissions: () => Promise.resolve(),
    getIdentity: () => {
        try {
            const token = localStorage.getItem('auth_token');
            if (!token) throw new Error();

            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            return Promise.resolve({
                id: decodedToken.username,
                fullName: `${decodedToken.first_name || ''} ${decodedToken.last_name || ''}`.trim(),
            });
        } catch (error) {
            return Promise.reject(error);
        }
    },
    refreshToken: () => {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) return Promise.reject();

        const url = baseUrl+'/v1/refresh';

        return fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Authorization': `Bearer ${refreshToken}`,
                'Content-Type': 'application/json',
            }),
        })
        .then(response => {
            if (response.status < 200 || response.status >= 300) {
                throw new Error('Failed to refresh token');
            }
            return response.json();
        })
        .then(auth => {
            localStorage.setItem('auth_token', auth.access_token);
            localStorage.setItem('refresh_token', auth.refresh_token);
            return Promise.resolve();
        })
        .catch(() => {
            authProvider.logout();
            return Promise.reject();
        });
    },
};

export default authProvider;

